import { render } from "./AdditionalFieldRules.vue?vue&type=template&id=311dbe24"
import script from "./AdditionalFieldRules.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldRules.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__